import React, { Component } from 'react'
import { Form } from 'redux-form'
import OperatorField from '../components/OperatorField'
import cn from 'classnames'
import Button from 'components/Button'
import sLay from 'styles/modules/layout.scss'
import sText from 'components/Text/Text.scss'

export default class MessageBodyIsForm extends Component {
  render() {
    const { handleSubmit, className, onSubmit, node, nodeInfo, formData, change } = this.props
    const submit = data => onSubmit(node, { extras: data })

    return (
      <Form onSubmit={handleSubmit(submit)} className={className}>
        <div style={{ paddingBottom: '15px' }} className={sText.descrip3}>
          This node allows you to route your flow based on a message a user has sent. Should only be
          used after an 'Incoming SMS' node.{' '}
          <a href={nodeInfo.helpUrl} target="_blank" rel="noopener noreferrer">
            {' '}
            Learn more.
          </a>
        </div>
        <OperatorField
          change={change}
          formData={formData}
          operators={['is', 'anyOf', 'contains', 'regex']}
        />
        <div className={sLay.flex} />
        <div className={cn(sLay['layout-column'])}>
          <Button type="submit" color="tertiary" rect>
            Save Node
          </Button>
        </div>
      </Form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/Flows/Flow/Nodes/MessageBodyIs/MessageBodyIsForm.jsx